import React from 'react'
import { COMPANY_INFO } from '../lib/constants'

export default function PriceBanner({ showCablePrice = true, compact = false }) {
  if (compact) {
    return (
      <div className="bg-[#FFFFFF] border border-slate-200 rounded-2xl p-6 my-6 shadow-sm">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-[#55565C]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
              <span>Gennemskuelige priser • Ingen overraskelser</span>
            </div>
            <div className="text-2xl font-extrabold text-[#18191D] mt-0.5">
              485 kr. <span className="text-sm font-medium text-[#55565C]">ex. moms pr. time</span>
            </div>
            <p className="text-xs text-[#55565C] mt-1">
              Inklusiv servicevogn. For Jakob er en time en time – uden skjulte tillæg.
            </p>
          </div>
          <a
            href={`tel:${COMPANY_INFO.phoneRaw}`}
            className="inline-flex items-center gap-2 rounded-full bg-[#18191D] hover:bg-[#292A30] text-white font-bold text-xs uppercase tracking-wider px-5 py-2.5 shadow-sm whitespace-nowrap transition-colors"
          >
            <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
            <span>Ring: {COMPANY_INFO.phone}</span>
          </a>
        </div>
      </div>
    )
  }

  return (
    <section className="relative bg-gradient-to-br from-[#14162B] via-[#1A1D36] to-[#121320] text-white rounded-3xl p-8 sm:p-12 my-12 shadow-2xl border border-[#2D346E]/50 overflow-hidden">
      {/* Subtle brand glow in the background */}
      <div
        className="absolute top-0 right-0 w-96 h-96 bg-[#252A6E]/30 rounded-full blur-3xl pointer-events-none -mr-20 -mt-20"
        aria-hidden="true"
      />
      <div
        className="absolute bottom-0 left-0 w-80 h-80 bg-[#1D2158]/40 rounded-full blur-3xl pointer-events-none -ml-20 -mb-20"
        aria-hidden="true"
      />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#B5BBE8] mb-2 bg-[#252A6E]/50 border border-[#3C449E]/40 px-3.5 py-1 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
            <span>Fast, ærlig afregning</span>
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white mt-3">
            Klare priser uden ubehagelige overraskelser
          </h2>
          <p className="text-[#9FA6D9] text-sm sm:text-base mt-2 max-w-2xl mx-auto">
            Jakob vægter ærlighed og direkte dialog højt. Du får en fast timepris og fuld gennemsigtighed på alt arbejde.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {/* Box 1: Timepris */}
          <div className="bg-[#1C203A]/85 border border-[#323A73]/60 hover:border-[#4B56B5] rounded-2xl p-6 text-center shadow-lg transition-all">
            <div className="text-3xl font-black text-white">
              485 kr.
            </div>
            <div className="text-[11px] font-bold text-[#A8B0E6] mt-1 uppercase tracking-wider">
              Ex. moms pr. time
            </div>
            <p className="text-xs text-[#8A91C2] mt-2">
              Servicevognen er regnet med i prisen. En time er en time.
            </p>
          </div>

          {/* Box 2: Servicevogn & Tillæg */}
          <div className="bg-[#1C203A]/85 border border-[#323A73]/60 hover:border-[#4B56B5] rounded-2xl p-6 text-center shadow-lg transition-all">
            <div className="text-3xl font-black text-white">
              0 kr.
            </div>
            <div className="text-[11px] font-bold text-[#A8B0E6] mt-1 uppercase tracking-wider">
              Ingen skjulte tillæg
            </div>
            <p className="text-xs text-[#8A91C2] mt-2">
              Servicevogn inkluderet. Ingen opstartsgebyrer eller uventede tillæg.
            </p>
          </div>

          {/* Box 3: Forsikring */}
          <div className="bg-[#1C203A]/85 border border-[#323A73]/60 hover:border-[#4B56B5] rounded-2xl p-6 text-center shadow-lg transition-all">
            <div className="text-3xl font-black text-white">
              100%
            </div>
            <div className="text-[11px] font-bold text-[#A8B0E6] mt-1 uppercase tracking-wider">
              Fuldt forsikret
            </div>
            <p className="text-xs text-[#8A91C2] mt-2">
              Forsikret ved el-installationer, arbejde i højden og havegravning.
            </p>
          </div>
        </div>

        {showCablePrice && (
          <div className="bg-[#1C203A]/70 border border-[#323A73]/60 rounded-2xl p-5 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
            <div className="flex items-center gap-3.5">
              <div className="w-10 h-10 rounded-full bg-[#252A6E] border border-[#3D45A0]/50 text-[#FFA459] flex items-center justify-center shrink-0">
                <i className="fa-solid fa-trowel-bricks text-sm" aria-hidden="true" />
              </div>
              <div>
                <span className="text-sm font-bold text-white block">
                  Kabelgravning & tildækning på private arealer
                </span>
                <span className="text-xs text-[#9FA6D9]">
                  Præcis og skånsom udgravning med minigraver og retablering
                </span>
              </div>
            </div>
            <div className="shrink-0">
              <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-white bg-[#252A6E] border border-[#3D45A0] px-4 py-2 rounded-full shadow-sm">
                Indhent tilbud
              </span>
            </div>
          </div>
        )}

        <div className="mt-8 text-center">
          <a
            href={`tel:${COMPANY_INFO.phoneRaw}`}
            className="inline-flex items-center justify-center gap-2.5 rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-7 py-3.5 shadow-md transition-all text-xs uppercase tracking-wider whitespace-nowrap"
          >
            <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
            <span>Ring til Jakob: {COMPANY_INFO.phone}</span>
          </a>
        </div>
      </div>
    </section>
  )
}
